module.exports = __webpack_public_path__ + "img/textInstructionIcon.98837e9f.svg";